/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-16 17:02:33
 * @FilePath: /vise/packages/app-share/src/constants/url.ts
 */
export const TRPC_CALL_PATH = 'https://api.weishi.qq.com/trpc.weishi.weishi_h5_proxy.weishi_h5_proxy';
export const TRPC_CALL_TEST_PATH = 'https://testapi.weishi.qq.com/trpc.weishi.weishi_h5_proxy.weishi_h5_proxy';
